import { createI18n } from 'vue-i18n'
import enUs from './en-us.json'
import zhCn from './zh-cn.json'

const messages = {
	'en-us': enUs,
	'zh-cn': zhCn
}

let locale = uni.getLocale();

if(uni.$storage.get("lang",null)){
	locale = uni.$storage.get("lang","zh-cn");
	// console.log('locale1',locale);
}else if(messages[locale] != undefined && typeof messages[locale] == 'object'){
	uni.$storage.set("lang",locale);
	// console.log('locale2',locale);
}else{
	locale = "zh-cn";
	// #ifdef H5
	let browserLang = navigator.language.toLowerCase();
	if(browserLang == 'zh-cn'){
		locale = browserLang;
	}else{
		locale = 'en-us';
	}
	// #endif
	
	uni.$storage.set("lang",locale);
}

export default createI18n({
  locale: locale,
  fallbackLocale: 'zh-cn',
  messages,
  silentTranslationWarn: true
})